import ProtectedRoute from 'components/ProtectedRoute'
import useFlag from 'hooks/useFlag'
import { Switch } from 'react-router-dom'
import MerchantUsers from 'scenes/MerchantUsers'
import EditMerchantUser from 'scenes/MerchantUsers/EditMerchantUser'
import NewMerchantUser from 'scenes/MerchantUsers/NewMerchantUser'
import { EditRole } from './EditRole'
import { DashboardAccess } from './index'

export const DashboardAccessRoutes = () => {
  const rbacEnabled = useFlag('role-based-access-control', false)

  if (!rbacEnabled) {
    return <MerchantUsers />
  }

  return (
    <Switch>
      <ProtectedRoute
        redirect="/"
        resource="MerchantUsers"
        component={EditRole}
        path="/merchant_users/roles/new"
        exact
      />
      <ProtectedRoute
        redirect="/"
        resource="MerchantUsers"
        component={EditRole}
        path="/merchant_users/roles/:id"
        exact
      />
      <ProtectedRoute
        redirect="/"
        resource="MerchantUsers"
        component={NewMerchantUser}
        path="/merchant_users/new"
        exact
      />
      <ProtectedRoute
        redirect="/"
        resource="MerchantUsers"
        component={EditMerchantUser}
        path="/merchant_users/edit/:id"
        exact
      />
      <ProtectedRoute
        redirect="/"
        resource="MerchantUsers"
        component={DashboardAccess}
        path="/merchant_users"
        exact
      />
    </Switch>
  )
}
